import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import LoadingSpinner from "../../../Shared/LoadingSpinner";
import { AiFillEye, AiFillEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import DeleteStudentModal from "../DeleteStudentModal/DeleteStudentModal";

const ManageStudent = () => {
  const [deleteStudent, setDeleteStudent] = useState(null);
  const {
    data: students,
    isLoading,
    refetch,
  } = useQuery(["students"], () =>
    fetch("https://evaluation-server.onrender.com/getStudents").then((res) =>
      res.json()
    )
  );

  if (isLoading) {
    return <LoadingSpinner></LoadingSpinner>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="table w-full text-center">
        {/* <!-- head --> */}
        <thead>
          <tr>
            <th>Sl no:</th>
            <th>Image</th>
            <th>Name</th>
            <th>Class</th>
            <th>Role</th>
            <th>View / Edit / Delete</th>
          </tr>
        </thead>
        <tbody>
          {students?.map((s, i) => (
            <tr key={s._id}>
              <th>{i + 1}</th>
              <td className="flex justify-center">
                <img className="w-10" src={s.image} alt="" />
              </td>
              <td>
                {s.firstName} {s.middleNam} {s.lastName}
              </td>
              <td>{s.classValue}</td>
              <td>{s.roll}</td>
              <td className="flex gap-4 justify-center">
                <Link to={`/viewStudent/${s._id}`}>
                  <AiFillEye className="text-2xl" />
                </Link>
                <Link to={`/editStudent/${s._id}`}>
                  <AiFillEdit className="text-2xl" />
                </Link>
                <label
                  onClick={() => setDeleteStudent(s._id)}
                  htmlFor="my-modal-6"
                  className="cursor-pointer"
                >
                  <AiOutlineDelete className="text-2xl" />
                </label>
                {deleteStudent && (
                  <DeleteStudentModal
                    refetch={refetch}
                    setDeleteStudent={setDeleteStudent}
                    deleteStudent={deleteStudent}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ManageStudent;
